import {
  OnInit,
  Component,
  ViewChild,
  ElementRef,
  ViewChildren,
  QueryList,
  PACKAGE_ROOT_URL,
  ViewEncapsulation,
} from '@angular/core';
import { LazyLoadEvent, MessageService, RadioButton, SelectItem, Dialog, Table } from 'primeng';
import { Message } from '../../classes/Message';
import { IJobScreen } from '../../interfaces/job/job';
import { IPageResult } from '../../interfaces/page-result';

import { ISupplierScheduleFilter } from '../../interfaces/supplier-schedule-filter';
import { Subject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { EventService, JobsService, UserService } from '../../services';
import { SupplierScheduleService } from '../../services';
import { flatten } from '../../utils/flatten';

import {
  ISupplierSchedule,
  ISupplierAvailabilityInfo,
  ISupplierScheduleSupplier,
  SupplierAvailabilityStateEnum,
} from '../../interfaces/supplier-schedule';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { CustomerService } from '../../services';
import { TaggingService } from '../../services';
import { SupplierInboxJobsService } from '../../services';
import { GoogleAnalyticsService } from '../../services';
import { OrganisationsService } from '../../services';
import { EngineiusAreaService, EngineiusRegionService } from '../../services';
import moment from 'moment';
import { JobRejectionReasonDTO } from '../../interfaces/job-rejection/job-rejection-reason.dto.interface';
import { RejectJobWithReasonDTO } from '../../interfaces/job-rejection/reject-job-with-reason.dto.interface';
import { JobRejectionReasonService } from '../../services/job-rejection/job-rejection-reasons.service';
import { JobAnalyticsService } from '../../services/product-analytics/job-analytics.service';
import { ImpersonationInfo } from 'src/app/interfaces/user';

@Component({
  selector: 'supplier-schedule-view',
  templateUrl: './supplier-schedule-view.component.html',
  styleUrls: ['./supplier-schedule-view.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class SupplierScheduleViewComponent implements OnInit {
  private Math = Math;

  private subscription: Subscription;
  public isLoading: boolean = true;
  public selectedItem: any;
  public selectedTask: any;
  public totalRecords: number;

  public jobId?: number;
  public jobInfo: IJobScreen;

  public jobOrders: SelectItem[] = [];
  public selectedJobOrder: any = null;

  public jobTasks: SelectItem[] = [];
  public selectedJobTask: any = null;

  public pageNumber = 1;
  public totalPages = 0;

  private isLoaded: boolean = false;

  public availabilityImageUrl = 'assets/images/calendar-clock.png';
  public availableImageUrl = 'assets/images/available.png';
  public notAvailableImageUrl = 'assets/images/unavailable.png';

  public page: IPageResult<ISupplierSchedule> = {
    items: [],
    total: 0,
  };

  @ViewChildren('colDay') dayColumns: QueryList<ElementRef>;
  @ViewChildren('dayOrder') dayOrders: QueryList<RadioButton>;
  @ViewChild('availabilityDialog') availabilityDialog: Dialog;
  @ViewChild('dt') dataTable: Table;

  public viewDates: Date[];

  public filter: Subject<ISupplierScheduleFilter>;
  public filterVal: ISupplierScheduleFilter;

  public radioButtonVal: string = 'day1';
  public filterButtonVal: string = 'work0';

  public classifications: SelectItem[] = [];
  public engineiusRegions: SelectItem[] = [];
  public engineiusAreas: SelectItem[] = [];
  public supplierList: SelectItem[] = [];
  public contractTypes: SelectItem[] = [];
  public organisationTags: SelectItem[] = [];
  public organisationSDGroups: SelectItem[] = [];
  public orderRadioButtonVal: string = 'orderPickup';

  // jvs = JobViewStatus (i.e. watched/rejected)
  public jvsRadioButtonVal: string = '0';

  public slice: ISupplierSchedule[] = [];
  public perPage: number = 50;

  public supplierAvailabilityInfo: ISupplierSchedule;
  public showSupplierAvailabilityDialog: boolean = false;

  isUserImpersonate = false;
  impersonatedUserGUID: string;

  public availCounts: {
    avail: number;
    unavail: number;
    notsure: number;
    availPerc: number;
    doNotDisturb: number;
  }[] = [];

  rejectJobDialogVisible = false;
  public rejectReasons: JobRejectionReasonDTO[] = [];
  public rejectReason: JobRejectionReasonDTO = null;
  public rejectText: string = null;
  supplierRejectingJob: any;

  constructor(
    private route: ActivatedRoute,
    private scheduleService: SupplierScheduleService,
    private messageService: MessageService,
    private jobService: JobsService,
    private router: Router,
    private customerService: CustomerService,
    private engineiusRegionService: EngineiusRegionService,
    private engineiusAreaService: EngineiusAreaService,
    private taggingService: TaggingService,
    private supplierInboxjobsService: SupplierInboxJobsService,
    private googleAnalyticsService: GoogleAnalyticsService,
    private organisationService: OrganisationsService,
    private jobRejectionReasonService: JobRejectionReasonService,
    private eventService: EventService,
    private jobAnalyticsService: JobAnalyticsService,
    private userService: UserService,
  ) {}

  ngOnInit() {
    this.jobRejectionReasonService.getJobRejectionReasons().then((res) => {
      this.rejectReasons = res;
    });

    this.filter = new Subject<ISupplierScheduleFilter>();
    this.initDefaultFilter();
    this.route.params.subscribe((params: Params) => {
      this.jobId = params['id'];

      if (this.jobId != undefined) {
        // modify the filter to reflect ordering by radius from job lat/long coords
        this.filterVal.filters.jobId.value = this.jobId;

        // load the job info
        this.jobService.get(this.jobId).then((job) => {
          this.jobInfo = job;

          // populate job orders for dropdown
          var l = [];
          if (job != null)
            job.orders.forEach((item) => l.push({ label: item.orderNumber, value: item }));
          this.jobOrders = l;

          // set the selected order to the first in the list by default
          if (this.jobOrders.length > 0) {
            this.selectedJobOrder = this.jobOrders[0].value;
            this.onSelectedJobOrderChanged(this.selectedJobOrder);
          }
        });
      }
    });

    // subscribe to filter changes with a debounce time
    if (!this.jobId) {
      this.subscription = this.filter.pipe(debounceTime(500)).subscribe((f) => {
        this.load(f);
        this.filterVal = f;
        this.isLoaded = true;
      });

      // set default filter
      this.filter.next(this.filterVal);
    }
  }

  initDefaultFilter() {
    this.filterVal = {
      first: 0,
      rows: 20,
      sortField: 'totalJobs',
      sortOrder: 1,
      filters: {
        supplierName: { value: null },
        fromDate: { value: moment(Date()).toDate() },
        toDate: { value: moment(Date()).add(3, 'd').toDate() },
        classifications: { value: ['New', 'Operational', 'Plated'] },
        engineiusRegionIds: { value: null },
        engineiusAreaIds: { value: null },
        supplierList: { value: null },
        dayOrder: { value: 0 },
        jobId: { value: null },
        orderId: { value: null },
        taskId: { value: null },
        orderPickup: { value: true },
        supplierId: { value: null },
        contractTypeIds: { value: [1] },
        scheduleSaturation: { value: 0 },
        organisationTagIds: { value: null },
        jobStatusView: { value: 0 },
        serviceDeliveryGroupIds: { value: null },
      },
    };

    // for testing need to use earlier dates as no tasks after dec 2019
    this.filterVal.filters.fromDate.value = new Date();
    this.onDateChange(new Date());
    this.userService.isUserImpersonating().then((res) => {
      var resultData: ImpersonationInfo;
      resultData = res;
      if (resultData != null) {
        this.isUserImpersonate = resultData.isImpersonating;
        this.impersonatedUserGUID = resultData.isImpersonating
          ? resultData.impersonatedUserGUID
          : resultData.originalUserId;
      }
    });
  }

  load(filter: ISupplierScheduleFilter) {
    this.isLoading = true;

    if (!this.classifications || this.classifications.length == 0) {
      this.scheduleService.getClassifications().then((res) => {
        let l = [];
        if (res != null)
          res.forEach((item) =>
            l.push({ label: item.name + ' (' + item.total + ')', value: item.name }),
          );
        this.classifications = l;

        //console.log("CLASSIFICATIONS: ", this.classifications);
      });
    }

    if (!this.engineiusRegions || this.engineiusRegions.length == 0) {
      this.engineiusRegionService.getAll().then((res) => {
        let l = [];
        if (res != null) res.forEach((item) => l.push({ label: item.name, value: item.id }));
        this.engineiusRegions = l.sort((a, b) => a.label.localeCompare(b.label));
      });
    }

    if (!this.engineiusAreas || this.engineiusAreas.length == 0) {
      this.engineiusAreaService.getAll().then((res) => {
        let l = [];
        if (res != null) res.forEach((item) => l.push({ label: item.name, value: item.id }));
        this.engineiusAreas = l.sort((a, b) => a.label.localeCompare(b.label));
      });
    }

    if (!this.contractTypes || this.contractTypes.length == 0) {
      this.customerService.getContractTypes().then((res) => {
        let l = [];
        if (res != null) res.forEach((item) => l.push({ label: item.name, value: item.id }));
        this.contractTypes = l;

        //console.log("CONTRACT TYPES: ", this.contractTypes);
      });
    }

    if (!this.organisationTags || this.organisationTags.length == 0) {
      this.taggingService.getAllTags().subscribe((res) => {
        let l = [];
        if (res != null) res.forEach((item) => l.push({ label: item.name, value: item.id }));
        this.organisationTags = l;

        //console.log("TAGS: ", this.organisationTags);
      });
    }

    if (!this.organisationSDGroups || this.organisationSDGroups.length == 0) {
      this.organisationService.getServiceDeliveryGroups().then((res) => {
        let l = [];
        if (res != null) res.forEach((item) => l.push({ label: item.name, value: item.id }));
        this.organisationSDGroups = l;
      });
    }

    //console.log("Schedule filter: ", flatten(filter));

    this.scheduleService.getSuppliersAndJobs(flatten(filter)).then(
      (result) => {
        this.page.items = result.items;
        this.page.total = result.total;

        // set availability counts

        // this.page.items.forEach(item => {
        //
        //   item.supplierAvailability = item.supplierAvailability.sort((a, b) => {
        //     return a.day - b.day;
        //   });
        //
        //   // switch the sunday index to line up with .day() day of week (0=Sunday, 6=Saturday)
        //   let t1 = item.supplierAvailability.splice(0, 1)[0];
        //
        //   item.supplierAvailability.push(t1);
        // });

        this.supplierList = [];

        this.availCounts = [];
        this.availCounts.push({ avail: 0, unavail: 0, notsure: 0, availPerc: 0, doNotDisturb: 0 });
        this.availCounts.push({ avail: 0, unavail: 0, notsure: 0, availPerc: 0, doNotDisturb: 0 });
        this.availCounts.push({ avail: 0, unavail: 0, notsure: 0, availPerc: 0, doNotDisturb: 0 });

        this.page.items.forEach((supplierSched, idx) => {
          supplierSched.isAvailable = [];
          supplierSched.availabilityState = [];
          this.viewDates.forEach((date, index) => {
            let state = this.getSupplierAvailability(supplierSched, date);

            supplierSched.isAvailable[index] = state
              ? state.availabilityState == SupplierAvailabilityStateEnum.available
              : null;

            supplierSched.availabilityState[index] = state
              ? state.availabilityState
              : SupplierAvailabilityStateEnum.unset;

            this.availCounts[index].avail +=
              state?.availabilityState == SupplierAvailabilityStateEnum.available ? 1 : 0;
            this.availCounts[index].unavail +=
              state?.availabilityState == SupplierAvailabilityStateEnum.unavailable ? 1 : 0;
            this.availCounts[index].doNotDisturb +=
              state?.availabilityState == SupplierAvailabilityStateEnum.doNotDisturb ? 1 : 0;
            this.availCounts[index].notsure += state?.availabilityState == null ? 1 : 0;
          });

          // Build a list of suppliers we can choose from
          this.supplierList.push({ label: supplierSched.supplierName, value: supplierSched.id });

          supplierSched.groupedTasks = [];

          supplierSched.tasks.forEach((dayTasks, idx2) => {
            dayTasks.forEach((taskItem, idx3) => {
              let uniqueKey =
                taskItem.pickupLocation.postcode +
                '-' +
                taskItem.dropoffLocation.postcode +
                '-' +
                taskItem.taskType +
                '-' +
                taskItem.pickupEarliestDateTime +
                '-' +
                taskItem.dropoffEarliestDateTime;

              if (typeof supplierSched.groupedTasks[idx2] === 'undefined') {
                supplierSched.groupedTasks[idx2] = {};
              }

              if (typeof supplierSched.groupedTasks[idx2][uniqueKey] === 'undefined') {
                supplierSched.groupedTasks[idx2][uniqueKey] = { tasks: [], taskSummary: null };
              }

              supplierSched.groupedTasks[idx2][uniqueKey].taskSummary = taskItem;
              supplierSched.groupedTasks[idx2][uniqueKey].tasks.push(taskItem);
            });
          });
        });

        // calculate availability percentage
        this.availCounts.forEach((data, index) => {
          let total = data.avail + data.unavail + data.notsure;

          //(take 50% of not-sure as being available)
          if (total > 0) {
            data.availPerc = ((data.avail + data.notsure * 0.5) / total) * 100.0;
          }
        });

        // Sort the suppliers
        this.supplierList = this.supplierList.sort((a, b) => {
          return a.value - b.value;
        });

        //console.log("Supplier schedule datas: ", this.page.items);
        //console.log("AVAIL Counts: ", this.availCounts);

        this.slice = this.page.items.slice(0, this.perPage);

        this.isLoading = false;
      },
      (error) => {
        this.messageService.add(Message.Error('Error loading data', 'Request Error'));
        this.isLoading = false;
      },
    );
  }

  onGridLazyLoad(event: LazyLoadEvent) {
    this.filterVal.first = event.first;
    this.filterVal.rows = event.rows;
    this.filterVal.sortField = event.sortField;
    this.filterVal.sortOrder = event.sortOrder;
    this.filter.next(this.filterVal);
  }

  loadLazy(event: LazyLoadEvent) {
    this.slice = this.page.items.slice(event.first, event.first + event.rows);
  }

  search() {
    this.setColumnDates();

    this.filterVal.first = 0;
    this.filter.next(this.filterVal);
  }

  ngAfterViewInit() {
    this.setColumnDates();
  }

  isPickupAnotherDay(task): boolean {
    //console.log("Earliest pickup: ", task.pickupEarliestDateTime, moment(task.pickupEarliestDateTime).dayOfYear, " / ", task.dropoffLatestDateTime, moment(task.dropoffLatestDateTime).dayOfYear);

    let anotherDay =
      moment(task.pickupEarliestDateTime).dayOfYear() !=
      moment(task.dropoffLatestDateTime).dayOfYear();
    return anotherDay;
  }

  isDropoffAnotherDay(task): boolean {
    let anotherDay =
      moment(task.dropoffLatestDateTime).dayOfYear() !=
      moment(task.pickupEarliestDateTime).dayOfYear();
    return anotherDay;
  }

  setColumnDates() {
    let dt = moment(this.filterVal.filters.fromDate.value).subtract(1, 'd');
    this.viewDates = Array(3)
      .fill(1)
      .map((y, m) => dt.add(1, 'd').toDate());

    dt = moment(this.filterVal.filters.fromDate.value);
    this.dayColumns.forEach((element) => {
      element.nativeElement.innerHtml = dt.format('dddd MMM Do YYYY');
      dt = dt.add(24, 'h');
    });

    dt = moment(this.filterVal.filters.fromDate.value);
    this.dayOrders.forEach((element) => {
      element.label = dt.format('ddd Do MMM');
      dt = dt.add(24, 'h');
    });
  }

  getTaskPickupDate(task) {
    let early = moment(task.pickupEarliestDateTime);
    let late = moment(task.pickupLatestDateTime);

    if (late.dayOfYear > early.dayOfYear) {
      return early.format('Do MMM HH:mm') + ' - ' + late.format('Do MMM HH:mm');
    } else {
      return early.format('ddd Do MMM HH:mm') + '-' + late.format('HH:mm');
    }
  }

  onDateChange(e) {
    this.filterVal.filters.toDate.value = moment(this.filterVal.filters.fromDate.value)
      .add(3, 'd')
      .toDate();
  }

  handleDay1OrderChange(e) {
    this.filterVal.filters.dayOrder.value = 0;
    this.search();
  }

  handleDay2OrderChange(e) {
    this.filterVal.filters.dayOrder.value = 1;
    this.search();
  }

  handleDay3OrderChange(e) {
    this.filterVal.filters.dayOrder.value = 2;
    this.search();
  }

  handleWorkFilterChange($event: any, filterId) {
    this.filterVal.filters.scheduleSaturation.value = filterId;
    this.search();
  }

  handleOrderByChange(e) {
    this.filterVal.filters.orderPickup.value = e == 'orderPickup';
    this.search();
  }

  onSelectedJobOrderChanged(jobOrder) {
    // set the filter order id
    this.filterVal.filters.orderId.value = jobOrder.id;

    // populate job tasks from selected order
    let order = this.jobInfo.orders.find((x) => x.id == jobOrder.id);

    var l = [];
    if (order != null)
      order.tasks.forEach((item) =>
        l.push({
          label: item.pickupLocation.postcode + ' to ' + item.dropoffLocation.postcode,
          value: item,
        }),
      );
    this.jobTasks = l;

    // set the selected task to the first in the list by default
    if (this.jobTasks.length > 0) {
      this.selectedJobTask = this.jobTasks[0].value;
      this.onSelectedJobTaskChanged(this.selectedJobTask);
    }
  }

  onSelectedJobTaskChanged(jobTask) {
    // set the filter task id and run the search to re-order results
    this.filterVal.filters.taskId.value = jobTask.id;

    // set filter from date to match job scheduled date
    this.filterVal.filters.fromDate.value = moment(this.jobInfo.scheduledDate).toDate();

    if (!this.isLoaded) {
      this.subscription = this.filter.pipe(debounceTime(500)).subscribe((f) => {
        this.load(f);
        this.filterVal = f;
        this.isLoaded = true;
      });

      // set default filter
      this.filter.next(this.filterVal);
    } else {
      this.search();
    }
  }

  editAvailability(row) {
    this.supplierAvailabilityInfo = row;

    // make the dialog visible
    this.showSupplierAvailabilityDialog = true;

    /* DB - dialog.center() Deprecated
    window.setTimeout(() => {
      this.availabilityDialog.center();
    }, 250);

     */
  }

  onSupplierAvailabilityClosed() {
    // send the two availability arrays back to the server to insert/update/delete the relevant data
    this.supplierAvailabilityInfo.supplierId = this.supplierAvailabilityInfo.id;
    this.scheduleService.setSupplierAvailability(this.supplierAvailabilityInfo).then((res) => {
      if (res) {
        this.messageService.add(Message.Info('Supplier availability updated'));
      }
    });
  }

  getSupplierAvailability(supplier: ISupplierSchedule, date: Date) {
    return this.scheduleService.getDayAvailabilityException(
      date,
      0,
      0,
      supplier.supplierAvailabilityExceptions,
    );
  }

  getAreaPostRegion(postcode: string) {
    let processed = postcode.toUpperCase().trim().slice(0, 7);

    var results = processed.match(/^[A-Z0-9]{2,4}(?=(?:\s*[A-Z0-9]{2,3})?$)/gm);
    if (results == null) {
      return '';
    } else return results[0];
  }

  stringToDuration(durationString: string) {
    return this.durationFormatMinutes(moment.duration(durationString).asMinutes());
  }

  durationFormatMinutes(duration: number) {
    return (
      moment.duration(duration, 'minutes').hours() +
      ' hr ' +
      moment.duration(duration, 'minutes').minutes() +
      ' min'
    );
  }

  handleJobViewStatusChange(e: any) {
    this.filterVal.filters.jobStatusView.value = +e;
    //console.log("Job status view set to: ", this.filterVal.filters.jobStatusView)

    this.search();
  }

  rejectJob(supplier) {
    this.supplierRejectingJob = supplier;

    // show rejection reason dialog to confirm/cancel
    this.rejectJobDialogVisible = true;
  }

  confirmedUnRejectJob(jobId: number) {
    this.supplierInboxjobsService.unRejectJob(jobId).then(() => {});
  }

  confirmedRejectJob() {
    this.rejectJobDialogVisible = false;

    this.googleAnalyticsService.eventEmitter(
      'reject_job',
      'supplier_schedule',
      'reject_job',
      'supplier_schedule_reject',
    );

    const dto = <RejectJobWithReasonDTO>{
      jobId: this.jobId,
      rejectionReasonId: this.rejectReason.id,
      reasonText: this.rejectText,
    };

    this.supplierInboxjobsService.rejectJobWithReason(dto).then(() => {
      const registrationNumber = this.jobInfo.orders.reduce((total, order) => {
        const orderRegistrationNumber = order.tasks.reduce(
          (sum, task) => sum + task.vehicle?.registrationNumber,
          '',
        );
        return total + orderRegistrationNumber;
      }, '');
      this.jobAnalyticsService.sendHideJobEvent(
        this.jobInfo.id,
        registrationNumber,
        this.rejectReason.reason,
        this.rejectText,
      );
      this.rejectJobDialogVisible = false;

      // update the supplier record manually
      this.supplierRejectingJob.jobRejected = true;
    });
  }

  showSelectLabels(choices: any, items: any, label: string) {
    if (items != null && items.length > 0) {
      if (items.length > 2) {
        return items.length + ' items';
      } else {
        return choices
          .filter((x) => items.includes(x.value))
          .map((x) => x.label)
          .join(', ');
      }
    }
    return 'Select  ' + label;
  }

  handleDayOrderChange(i: number) {
    this.radioButtonVal = 'day' + (i + 1);
    this.filterVal.filters.dayOrder.value = i;
    this.search();
  }

  protected readonly SupplierAvailabilityStateEnum = SupplierAvailabilityStateEnum;
}
